import React from 'react';

import { FlexBox } from 'ml-rubiks-styleguide/src/box';
import { IconButton } from 'ml-rubiks-styleguide/src/button';
import { IconArrowBack } from 'ml-rubiks-styleguide/src/icon';
import { Typography } from 'ml-rubiks-styleguide/src/typography';

import { useI18n } from '../../contexts/i18n-context';
import { PaymentMethodHeaderProps } from '../../types';

export const PaymentMethodHeader: React.FC<PaymentMethodHeaderProps> = ({
    title,
    onBack
}) => {
    const { t } = useI18n();

    return (
        <FlexBox vAlign="center" hAlign="space-between">
            <FlexBox vAlign="center">
                {onBack && (
                    <IconButton
                        onClick={onBack}
                        aria-label={t('upc.aria.go.back', 'Go back')}
                        sx={{ mr: 1.5 }}
                    >
                        <IconArrowBack color="text.secondary" />
                    </IconButton>
                )}
                <Typography variant="headingMedium"
                    color="text.primary"
                    sx={{ fontSize: { xs: '1rem', sm: '1.125rem' } }}
                >
                    {title}
                </Typography>
            </FlexBox>
        </FlexBox>
    );
};
